module.exports = __webpack_public_path__ + "static/img/8.917b906.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/eng/8.png
// module id = jsYR
// module chunks = 0